import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Table,
  Card,
  Tag,
  Input,
  Button,
  Tooltip,
  Modal,
  Image,
  Select,
  message,
} from "antd";
import {
  req_list_pim_overtime_log_self,
  req_add_pim_staff_overtime,
} from "../../api";
import { getDateYYYYMM, formateHHMMDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import OverTimeStaffAddModal from "./over-time-staff-add-modal";
import { API_BASE } from "../../utils/contrains";

class OverTimeLogStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    searchField: "None",
    searchValue: "",
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    item: {},
    isAddModal: false,
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_overtime_log_self(
      userLevel,
      userCode,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      //console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_overtime(item, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  // 樣式設定 //////////////////////////////////////////////
  statusApplyDescription = (Status) => {
    switch (Status) {
      case "APPLY":
        return "申請中";
      case "AY":
        return "單位二級主管通過";
      case "BY":
        return "單位一級主管通過";
      case "CY":
        return "人事室承辦人通過";
      case "DY":
        return "人事室承辦主管通過";
      case "EY":
        return "人事室主任通過";
      case "ALLAGREE":
        return "申請已通過";
      case "AN":
        return "單位二級主管未通過";
      case "BN":
        return "單位一級主管未通過";
      case "CN":
        return "人事室承辦人未通過";
      case "DN":
        return "人事室承辦主管未通過";
      case "EN":
        return "人事室主任未通過";
      case "ZN":
        return "註銷";
      default:
        return "申請未通過";
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
          case "休息日加班":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          case "工作日加班":
            return "orange";
          default:
            return "default";
        }
      case "TYPE_APPLY":
        switch (param) {
          case "補簽到退申請":
            return "blue";
          case "工作日加班申請":
            return "orange";
          case "休息日加班申請":
            return "red";
          case "平假日調換申請":
            return "purple";
          case "工作日調移申請":
            return "Tan";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS_WORK":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      case "STATUS_APPLY":
        switch (param) {
          case "APPLY":
            return "blue";
          case "AY":
            return "blue";
          case "BY":
            return "blue";
          case "CY":
            return "blue";
          case "DY":
            return "blue";
          case "EY":
            return "blue";
          case "ALLAGREE":
            return "green";
          case "AN":
            return "red";
          case "BN":
            return "red";
          case "CN":
            return "red";
          case "DN":
            return "red";
          case "EN":
            return "red";
          case "ZN":
            return "red";
          default:
            return "blue";
        }
      case "STATUS_CONFIRM":
        switch (param) {
          case "NO":
            return "red";
          case "YES":
            return "green";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_btn_cancel = (item) => {
    const { userName, userCode } = this.props.user;
    const { OvertimeDate, Id, Uid } = item;
    console.log(item);
    Modal.confirm({
      title: `您確定註銷此筆資料嗎?`,
      onOk: () => {
        const row_flix = {
          Uid: Uid,
          OvertimeDate: OvertimeDate,
          OvertimeCaseId: Id,
          OvertimeStatus: "ZN",
          OperatorCode: userCode,
          OperatorDescription: "由" + userName + "註銷",
          condition: "BASE",
        };
        this.api_modify_item(row_flix);
      },
    });
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "80px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { ApplyStatus } = item;
          return (
            <>
              {" "}
              {ApplyStatus === "ALLAGREE" ? (
                <>
                  <button
                    className={
                      ApplyStatus === "ALLAGREE"
                        ? "btn btn-warning btn-sm"
                        : "btn btn-info btn-sm"
                    }
                    onClick={() => this.handle_btn_cancel(item)}
                  >
                    <i className="fas fa-calendar-times"></i> 註銷
                  </button>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
      {
        title: "申請分類",
        dataIndex: "OvertimeReason",
        key: "OvertimeReason",
        align: "center",
        width: 80,
        filters: [
          {
            text: "工作日加班",
            value: "工作日加班",
          },
          {
            text: "休息日加班",
            value: "休息日加班",
          },
        ],
        // specify the condition of filtering result
        // here is that finding the name started with `value`
        onFilter: (value, record) => record.OvertimeReason.indexOf(value) === 0,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("REASON", text)}>
              {text}
            </Tag>
          </>
        ),
      },
      {
        title: "審查狀況",
        dataIndex: "ApplyStatus",
        key: "ApplyStatus",
        align: "center",
        width: 80,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("STATUS_APPLY", text)}>
              {this.statusApplyDescription(text)}
            </Tag>
          </>
        ),
      },
      {
        title: "職號",
        width: "40px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { StaffCode } = item;
          return <span style={{ fontWeight: 900 }}>{StaffCode}</span>;
        },
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        key: "StaffName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "加班日期",
        dataIndex: "OvertimeDate",
        key: "OvertimeDate",
        align: "center",
        width: 80,
        render: (text) => <>{text}</>,
      },
      {
        title: "起始時間",
        dataIndex: "OvertimeClockStart",
        key: "OvertimeClockStart",
        align: "center",
        width: 80,
        render: (text) => <>{formateHHMMDate(text)}</>,
      },
      {
        title: "結束時間",
        dataIndex: "OvertimeClockEnd",
        key: "OvertimeClockEnd",
        align: "center",
        width: 80,
        render: (text) => <>{formateHHMMDate(text)}</>,
      },
      {
        title: "申請說明",
        width: 100,
        render: (item) => {
          const url = item.ReasonFileUrl;
          const isPdf = url && url.toLowerCase().endsWith(".pdf");

          const handleClick = (e) => {
            e.preventDefault();
            if (isPdf) {
              window.open(API_BASE + url, "_blank", "noopener,noreferrer");
            }
          };

          return (
            <>
              {url ? (
                isPdf ? (
                  <a
                    href={API_BASE + url}
                    onClick={handleClick}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="fas fa-file-pdf"
                      style={{ fontSize: 25, color: "#d9534f" }}
                    ></i>
                  </a>
                ) : (
                  <Image width={25} height={25} src={API_BASE + url} />
                )
              ) : null}
              {item.RecordDescription}
            </>
          );
        },
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const {
      data,
      loading,
      nowYearMonth,
      isAddModal,
      searchField,
      searchValue,
    } = this.state;
    const title = (
      <div>
        <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">請選擇</Select.Option>
          <Select.Option value="OvertimeDate">簽到退日期</Select.Option>
          <Select.Option value="StaffCode">職號</Select.Option>
          <Select.Option value="StaffName">姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Tooltip placement="top" title="加班補登">
          <Button
            type="primary"
            onClick={() => this.setState({ isAddModal: true })}
            danger
          >
            <i className="fas fa-calendar-plus"></i>
            <span style={{ marginLeft: "4px" }}>單筆新增</span>
          </Button>
        </Tooltip>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={300}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OverTimeStaffAddModal />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(OverTimeLogStaff);
